import { render, staticRenderFns } from "./inbraakonderzoekBedankt.vue?vue&type=template&id=061fdf72"
import script from "./inbraakonderzoekBedankt.vue?vue&type=script&lang=js"
export * from "./inbraakonderzoekBedankt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports